import { ReferencedEntry } from 'contentful';
import { useEffect, useState } from 'react';

import { SpeedBumpList } from 'src/api/contentful/contentTypes.shop';

import { fetchSpeedBumpList } from './Util';

export function useSpeedbumpEntry(locale: string, initialEntry?: ReferencedEntry<SpeedBumpList>) {
  const [ speedbumpEntry, setSpeedbumpEntry ] = useState<ReferencedEntry<SpeedBumpList> | undefined>(initialEntry);

  useEffect(() => {
    if (speedbumpEntry) return;
    fetchSpeedBumpList(locale).then(entry => setSpeedbumpEntry(entry));
  }, [ speedbumpEntry ]);

  return { speedbumpEntry };
}
